import axios from "axios";
import { BASE_URL } from "../common/config";

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 1000 * 60,
  // headers: {
  //     'Access-Control-Allow-Origin': '*',
  //     'Access-Control-Allow-Method': 'PUT, GET, POST, DELETE, OPTIONS',
  //     'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
  //     'Access-Control-Allow-Credentials': 'true'
  // }
});

// const getRefreshToken = () => {
//     axios
//         .get(
//             BASE_URL + "api/refresh",
//             {
//                 params: {
//                     token: localStorage.getItem("token"),
//                 },
//                 headers: {
//                     Accept: "application/json",
//                     "Content-Type": "application/json",
//                 },
//                 data: {}
//             }
//         )
//         .then((res) => {
//             return res.data.access_token;
//         })
//         .catch((err) => {
//             return;
//         });
// };

const getRefreshToken = async () => {
  try {
    const res = await axios.get(BASE_URL + "/api/auth/refresh-token", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-refresh-token": localStorage.getItem("refresh_token"),
      },
      data: null,
    });
    return res.data.data;
  } catch (err) {
    return null;
  }
};

instance.interceptors.request.use(
  async (config) => {
    config.headers = {
      ...config.headers,
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth-token": localStorage.getItem("token"),
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    };
    config.params = {
      ...config.params,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 410 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const access_token = await getRefreshToken();
      if (access_token) {
        localStorage.setItem("token", access_token);
      } else {
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("user_umur");
      }
      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
